import { render } from "./SuggestionTitle.vue?vue&type=template&id=712fe8bc&scoped=true"
import script from "./SuggestionTitle.vue?vue&type=script&lang=js"
export * from "./SuggestionTitle.vue?vue&type=script&lang=js"

import "./SuggestionTitle.vue?vue&type=style&index=0&id=712fe8bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712fe8bc"]])

export default __exports__